webpackJsonp([123456214609689],{

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code, and use
		// it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var InvalidCharacterError = function(message) {
			this.message = message;
		};
		InvalidCharacterError.prototype = new Error;
		InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
		var error = function(message) {
			// Note: the error messages used throughout this file match those used by
			// the native `atob`/`btoa` implementation in Chromium.
			throw new InvalidCharacterError(message);
		};
	
		var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		// http://whatwg.org/html/common-microsyntaxes.html#space-character
		var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
	
		// `decode` is designed to be fully compatible with `atob` as described in the
		// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
		// The optimized base64-decoding algorithm used is based on @atk’s excellent
		// implementation. https://gist.github.com/atk/1020396
		var decode = function(input) {
			input = String(input)
				.replace(REGEX_SPACE_CHARACTERS, '');
			var length = input.length;
			if (length % 4 == 0) {
				input = input.replace(/==?$/, '');
				length = input.length;
			}
			if (
				length % 4 == 1 ||
				// http://whatwg.org/C#alphanumeric-ascii-characters
				/[^+a-zA-Z0-9/]/.test(input)
			) {
				error(
					'Invalid character: the string to be decoded is not correctly encoded.'
				);
			}
			var bitCounter = 0;
			var bitStorage;
			var buffer;
			var output = '';
			var position = -1;
			while (++position < length) {
				buffer = TABLE.indexOf(input.charAt(position));
				bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
				// Unless this is the first of a group of 4 characters…
				if (bitCounter++ % 4) {
					// …convert the first 8 bits to a single ASCII character.
					output += String.fromCharCode(
						0xFF & bitStorage >> (-2 * bitCounter & 6)
					);
				}
			}
			return output;
		};
	
		// `encode` is designed to be fully compatible with `btoa` as described in the
		// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
		var encode = function(input) {
			input = String(input);
			if (/[^\0-\xFF]/.test(input)) {
				// Note: no need to special-case astral symbols here, as surrogates are
				// matched, and the input is supposed to only contain ASCII anyway.
				error(
					'The string to be encoded contains characters outside of the ' +
					'Latin1 range.'
				);
			}
			var padding = input.length % 3;
			var output = '';
			var position = -1;
			var a;
			var b;
			var c;
			var d;
			var buffer;
			// Make sure any padding is handled outside of the loop.
			var length = input.length - padding;
	
			while (++position < length) {
				// Read three bytes, i.e. 24 bits.
				a = input.charCodeAt(position) << 16;
				b = input.charCodeAt(++position) << 8;
				c = input.charCodeAt(++position);
				buffer = a + b + c;
				// Turn the 24 bits into four chunks of 6 bits each, and append the
				// matching character for each of them to the output.
				output += (
					TABLE.charAt(buffer >> 18 & 0x3F) +
					TABLE.charAt(buffer >> 12 & 0x3F) +
					TABLE.charAt(buffer >> 6 & 0x3F) +
					TABLE.charAt(buffer & 0x3F)
				);
			}
	
			if (padding == 2) {
				a = input.charCodeAt(position) << 8;
				b = input.charCodeAt(++position);
				buffer = a + b;
				output += (
					TABLE.charAt(buffer >> 10) +
					TABLE.charAt((buffer >> 4) & 0x3F) +
					TABLE.charAt((buffer << 2) & 0x3F) +
					'='
				);
			} else if (padding == 1) {
				buffer = input.charCodeAt(position);
				output += (
					TABLE.charAt(buffer >> 2) +
					TABLE.charAt((buffer << 4) & 0x3F) +
					'=='
				);
			}
	
			return output;
		};
	
		var base64 = {
			'encode': encode,
			'decode': decode,
			'version': '0.1.0'
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return base64;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = base64;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in base64) {
					base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.base64 = base64;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(539)(module), (function() { return this; }())))

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _base = __webpack_require__(236);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	**
	**  Component to handle Push Manager subscriptions
	*/
	
	// Puzzle for someday: why could I use atob() in the service worker w/o problems?
	
	
	// Component-global variables
	var isSubscribed = false;
	var swSub, swReg;
	var label;
	
	// This key is made to talk to notifier at www.scene-history.org
	var applicationServerPublicKey = 'BJZhZZUqIwbwbGci_pheC3wTwNFcF5btmH7JPCFCF22gk7iJaXmrLznrtBQI_C_HtWZh9BFnwCVKfz7oVgTmaPA';
	var applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
	
	// Wrap an HTML button into a subscribe buttoncomponent
	var buttonStyle = {
	  margin: '10px 10px 10px 0'
	
	  // Button, with a variety of DOM API methods to do notification subscriptions
	};
	var SubscribeButton = function (_React$Component) {
	  _inherits(SubscribeButton, _React$Component);
	
	  function SubscribeButton(props) {
	    _classCallCheck(this, SubscribeButton);
	
	    // Assume browser can do push until we learn otherwise
	    var supportsPush = true;
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.updateBtn = function () {
	      // Save context for promise handlers
	      var outerThis = _this;
	      // Toggle button; call appropriate handler to sub/unsubscribe
	      if (isSubscribed) {
	        unsubscribeUser().then(function (subscription) {
	          isSubscribed = false;
	          console.log('Regular unsubscribe ' + subscription);
	          label = isSubscribed ? 'Unsubscribe' : 'Subscribe';
	          outerThis.setState(function (state) {
	            return { label: label };
	          });
	        }).catch(function (error) {
	          console.log('Error unsubscribing', error);
	          isSubscribed = false;
	          console.log('In unsubscribe error ' + subscription);
	          label = isSubscribed ? 'Unsubscribe' : 'Subscribe';
	          outerThis.setState(function (state) {
	            return { label: label };
	          });
	        });
	        console.log('After unsubscribe ' + isSubscribed);
	      } else {
	        // Create subscription and send to back end
	        subscribeUser().then(function (subscription) {
	          // The subscription was successful
	          // Should we include error checking for this next function?
	          sendSubscriptionToBackEnd(subscription);
	          console.log('Service worker subscribed' + JSON.stringify(subscription));
	          isSubscribed = true;
	          // Save for use outside of handler
	          swSub = subscription;
	          console.log('In subscribe ' + isSubscribed);
	          label = isSubscribed ? 'Unsubscribe' : 'Subscribe';
	          outerThis.setState(function (state) {
	            return { label: label };
	          });
	        }).catch(function (error) {
	          // No good
	          isSubscribed = false;
	          label = 'Unsubscribe';
	          outerThis.setState(function (state) {
	            return { label: label };
	          });
	          // These should create modals to report status (soon)
	          //   and probably also change page verbiage
	          if (Notification.permission === 'denied') {
	            // User has not consented to notifications
	            console.log('Permission for Notifications was denied');
	          } else {
	            // Browser won't allow the registration
	            console.log('Unable to subscribe to push.', error);
	            label = 'No browser support';
	            outerThis.setState(function (state) {
	              return { label: label };
	            });
	            outerThis.setState(function (state) {
	              return { pushSupport: false };
	            });
	            localStorage.setItem('push', 'false');
	          }
	        });
	      }
	    };
	
	    label = isSubscribed ? 'Unsubscribe' : 'Subscribe';
	    // Do we suport local storage?  If so, what about push support?
	    if (supports_html5_storage()) {
	      supportsPush = localStorage.getItem('push') != 'false';
	      console.log("Local storage push support: " + supportsPush);
	    }
	    label = supportsPush ? 'Subscribe' : 'No browser support';
	    _this.state = {
	      label: label,
	      pushSupport: supportsPush
	    };
	    return _this;
	  }
	
	  SubscribeButton.prototype.componentDidMount = function componentDidMount() {
	    // We need context inside promise handler
	    var outerThis = this;
	    // See if browser supports push notifications
	    //   Note: Brave lies about this and returns true!!
	    //   Also note: we can't do this in constructor; no DOM yet
	    if (!('PushManager' in window)) {
	      console.log("Push not supported on this browser");
	      this.setState({ pushSupport: false });
	      this.setState({ label: 'No browser support' });
	    } else {
	      console.log("Browser supports push");
	    }
	    // Get service worker, then use it to test subscribe status
	    //  Note: maybe also check browser compat here??
	    console.log('Supports push: ' + this.state.pushSupport);
	    // Need the service worker in order to subscribe
	    navigator.serviceWorker.getRegistration('/').then(function (registration) {
	      swReg = registration;
	      // We may already know push is not supported
	      if (outerThis.state.pushSupport) {
	        swReg.pushManager.getSubscription().then(function (subscription) {
	          swSub = subscription;
	          isSubscribed = swSub != null;
	          // Develop mode in Gatsby doesn'twork for service workers
	          //   and so lots of debugging was needed
	          console.log("Reg object " + swReg);
	          console.log("Sub object: " + swSub);
	          console.log("Mount check is subscribed: " + isSubscribed);
	          // Set label based on subscribe status
	          label = isSubscribed ? 'Unsubscribe' : 'Subscribe';
	          console.log('About to set initial button as ' + label);
	          outerThis.setState(function (state) {
	            return { label: label };
	          });
	        });
	      }
	    });
	    // Experimental "feature"
	    send_message_to_sw('You old dogface!!');
	  };
	
	  // Click handler for Subscribe button
	
	
	  SubscribeButton.prototype.render = function render() {
	    return _react2.default.createElement(
	      "button",
	      {
	        className: "btn btn-primary js-push-btn mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect",
	        style: buttonStyle,
	        disabled: !this.state.pushSupport,
	        onClick: this.updateBtn },
	      this.state.label
	    );
	  };
	
	  return SubscribeButton;
	}(_react2.default.Component);
	
	function subscribeUser() {
	  // Return subscription request promise to caller
	  console.log("Subscribe user " + swSub);
	  return swReg.pushManager.subscribe({
	    userVisibleOnly: true,
	    applicationServerKey: applicationServerKey
	  });
	}
	
	function unsubscribeUser() {
	  // Return promise to calling function
	  console.log("Unsubscribe user " + swSub);
	  return swSub.unsubscribe();
	}
	
	// Service routine to create Uint8 array for subscribe
	function urlB64ToUint8Array(base64String) {
	  var padding = '='.repeat((4 - base64String.length % 4) % 4);
	  var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
	
	  var rawData = _base2.default.decode(base64);
	  var outputArray = new Uint8Array(rawData.length);
	
	  for (var i = 0; i < rawData.length; ++i) {
	    outputArray[i] = rawData.charCodeAt(i);
	  }
	  return outputArray;
	}
	
	// Service routine to contact our speciic server
	function sendSubscriptionToBackEnd(subscription) {
	  // Convert the subscription to a simple object
	  var bodyObject = subscription.toJSON();
	
	  // Add selected tags to request object
	  // Totally cheating here no so as not to break scene-history server
	  var tagList = { tags: ["image"] };
	  bodyObject = _extends({}, bodyObject, tagList);
	  // console.log('Body object: ' + JSON.stringify(bodyObject))
	
	  // This will eventually be sent to a notification microservice
	  return fetch('https://www.scene-history.org/save-subscription/', {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify(bodyObject)
	  }).then(function (response) {
	    if (!response.ok) {
	      throw new Error('Bad status code from server.');
	    }
	    // console.log('Subscribe response: ' + JSON.stringify(reponse.data))
	    return response.json();
	  }).then(function (responseData) {
	    if (!(responseData.data && responseData.data.success)) {
	      throw new Error('Bad response from server.');
	    }
	    console.log(JSON.stringify(responseData.data));
	  });
	}
	
	// Experimental code
	function send_message_to_sw(msg) {
	  return new Promise(function (resolve, reject) {
	    // Create a Message Channel
	    var msg_chan = new MessageChannel();
	
	    // Handler for recieving message reply from service worker
	    msg_chan.port1.onmessage = function (event) {
	      if (event.data.error) {
	        reject(event.data.error);
	      } else {
	        resolve(event.data);
	        console.log(event.data);
	      }
	    };
	
	    // Send message to service worker along with port for reply
	    navigator.serviceWorker.controller.postMessage("Client 1 says '" + msg + "'", [msg_chan.port2]);
	  });
	}
	
	// Does browser support local storage?
	function supports_html5_storage() {
	  try {
	    return 'localStorage' in window && window['localStorage'] !== null;
	  } catch (e) {
	    return false;
	  }
	}
	// For future reference; handles different classes of notification
	/*
	  // Called for each select/deselect of a topic
		handleSelectChange = (value) => {
			this.setState({ value },function(){
	      tagValues = this.state.value
	      console.log('Value = ' + this.state.value + ' ' + JSON.stringify(tagValues))
	    })
		}
	  */
	
	exports.default = SubscribeButton;
	module.exports = exports["default"];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SubscribeButton = __webpack_require__(218);
	
	var _SubscribeButton2 = _interopRequireDefault(_SubscribeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Page to handle push notification subscriptions
	var Notify = function Notify(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Notifications - Sunny Crest'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Subscription Page' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Subscribe to important notifications about Sunny Crest'
	                        )
	                    ),
	                    _react2.default.createElement(_SubscribeButton2.default, null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We can notify you about upcoming events, important milestones, etc.  We promise not to pester you!!',
	                        _react2.default.createElement('br', null),
	                        'Click to subscribe or unsubscribe from this service'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Notify;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-notify-js-b93165137d1e0bf2b47b.js